import moment, { MomentInput } from 'moment'
import config from '@/config/app'
import { XDayOfWeek } from '@/types/generated/graphql'
require('moment/locale/ja')

export type InitialOptions = {
  lang: string
}

export const initMoment: (options: InitialOptions) => void = (
  options: InitialOptions
) => {
  moment.locale(options.lang)
}

initMoment({ lang: config.locale })

export default moment

/**
 * Utils
 */

export type IsoDayOfWeek = 1 | 2 | 3 | 4 | 5 | 6 | 7

const isoDayOfWeeks: { [key in XDayOfWeek]: IsoDayOfWeek } = {
  [XDayOfWeek.Monday]: 1,
  [XDayOfWeek.Tuesday]: 2,
  [XDayOfWeek.Wednesday]: 3,
  [XDayOfWeek.Thursday]: 4,
  [XDayOfWeek.Friday]: 5,
  [XDayOfWeek.Saturday]: 6,
  [XDayOfWeek.Sunday]: 7,
}

const xDayOfWeek = (isoDow: IsoDayOfWeek): XDayOfWeek => {
  const xDayOfWeeks = Object.keys(isoDayOfWeeks) as XDayOfWeek[]
  return xDayOfWeeks.find((key) => isoDayOfWeeks[key] === isoDow) as XDayOfWeek
}

export const dayOfWeekOf = (date: MomentInput): XDayOfWeek => {
  const isoDayOfWeek = moment(date).isoWeekday() as IsoDayOfWeek
  return xDayOfWeek(isoDayOfWeek)
}
